import { Accordion, Form, Modal } from "react-bootstrap";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import Select from 'react-select';
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { userSignal } from "../../../signal/userSignal";
import axios from "axios";
import { DEV_SERVER } from "../../../constants/urls";
import { dealerSignal } from "../../../signal/dealerSignal";
import MapModal from "../maps/MapModal";

export default function EditTaskModal(props) {

    const [trip, setTrip] = useState({
        id: props?.trip?.id,
        tasks: props?.trip?.tasks
    })
    const [showMap, setShowMap] = useState(false)
    const [selectedTask, setSelectedTask] = useState(-1)

    const updateTasksMutation = useMutation((body) => {
        let resp = axios.put(`${DEV_SERVER}/trip/v2/task/${body.id}`, body.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp
    }, {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.refetchTrip()
                props?.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleLocationSelecion = (selectedCoordinates, address) => {
        let taskId = selectedTask
        let newTasks = [...trip.tasks]
        newTasks[taskId].destinationLocation = [selectedCoordinates.lat, selectedCoordinates.lng]
        newTasks[taskId].destinationArea = address.area
        newTasks[taskId].destinationCity = address.city
        newTasks[taskId].destinationState = address.state
        setTrip({ ...trip, tasks: newTasks })
    }

    const handleEditTask = () => {

        let tasks = trip.tasks
        for (let i = 0; i < tasks.length; i++) {
            let task = tasks[i]
            if (task?.dealerId === "" || task?.dealerId === undefined || task?.dealerId === null) {
                delete tasks[i].dealerId
            }
        }
        let body = {
            id: trip.id,
            body: { tasks: tasks }
        }
        updateTasksMutation.mutate(body)
    }

    return <Modal show={props.show} fullscreen onHide={() => props.close()}>
        <Modal.Header closeButton>
            <Modal.Title>Edit Tasks</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex align-items-center flex-column" style={{ rowGap: "1rem" }}>

            <div className="w-50 d-flex justify-content-end">
                <button className="btn btn-light" onClick={() => {
                    let newTask = {
                        title: `Task ${trip.tasks.length + 1}`,
                        description: "",
                        destinationArea: "",
                        destinationCity: "",
                        destinationState: "",
                        destinationLocation: [0.0, 0.0],
                        dealerId: "",
                        assignedBy: userSignal.value?.user?.id
                    }
                    setTrip({ ...trip, tasks: [...trip.tasks, newTask] })
                }}>Add Task</button>
            </div>

            <Accordion className="w-50">
                {
                    trip.tasks.map((task, index) => {
                        return <div key={index} className="d-flex justify-content-between" style={{ columnGap: "1rem" }}>

                            <Accordion.Item className="w-100 mt-2" eventKey={index.toString()} >
                                <Accordion.Header style={{ backgroundImage: "initial" }}>
                                    <div className="d-flex justify-content-between w-100">
                                        <span>{task?.title}</span>

                                    </div>
                                </Accordion.Header>
                                <Accordion.Body className="d-flex flex-column" style={{ rowGap: "1rem" }}>

                                    <Form.Group className="w-100" controlId="formBasicTitle">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control value={task?.title} onChange={(e) => {
                                            let newTasks = [...trip.tasks]
                                            newTasks[index].title = e.target.value
                                            setTrip({ ...trip, tasks: newTasks })
                                        }} type="text" placeholder="Enter Title" />
                                    </Form.Group>
                                    <Form.Group className="w-100" controlId="formBasicDescription">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control value={task?.description} onChange={(e) => {
                                            let newTasks = [...trip.tasks]
                                            newTasks[index].description = e.target.value
                                            setTrip({ ...trip, tasks: newTasks })
                                        }} type="text" placeholder="Enter Description" />
                                    </Form.Group>
                                    <Form.Group className="w-100" controlId="formBasicDealer">
                                        <Form.Label>Dealer</Form.Label>
                                        <Select
                                            as="select"
                                            value={{ label: dealerSignal.value[task?.dealerId]?.name, value: task?.dealerId }}
                                            onChange={(e) => {
                                                let newTasks = [...trip.tasks]
                                                newTasks[index].dealerId = e?.value
                                                newTasks[index].destinationArea = dealerSignal.value[e?.value]?.address || ""
                                                newTasks[index].destinationCity = dealerSignal.value[e?.value]?.city || ""
                                                newTasks[index].destinationState = dealerSignal.value[e?.value]?.state || ""
                                                setTrip({ ...trip, tasks: newTasks })
                                            }}
                                            options={Object.entries(dealerSignal.value).map(([key, value]) => {
                                                return (
                                                    {
                                                        label: value?.name,
                                                        value: key.toString()
                                                    }
                                                )
                                            })}
                                            isSearchable
                                            isClearable
                                        />
                                    </Form.Group>
                                    <Form.Group className="w-100" controlId="formBasicDestinationArea">
                                        <Form.Label>Destination Area</Form.Label>
                                        <div className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                                            <Form.Control value={task?.destinationArea} onChange={(e) => {
                                                let newTasks = [...trip.tasks]
                                                newTasks[index].destinationArea = e.target.value
                                                setTrip({ ...trip, tasks: newTasks })
                                            }} type="text" placeholder="Enter Destination Area" />
                                            <i className="fa fa-map" style={{ cursor: "pointer", color: '#EA6A12' }} onClick={() => {
                                                setSelectedTask(index)
                                                setShowMap(true)
                                            }} />
                                        </div>
                                    </Form.Group>
                                    <div className="d-flex align-items-center col-12 mx-auto" style={{ rowGap: "1rem", columnGap: "1rem" }}>
                                        <Form.Group className="col-6" controlId="formBasicDestinationCity">
                                            <Form.Label>Destination City</Form.Label>
                                            <Form.Control value={task?.destinationCity} onChange={(e) => {
                                                let newTasks = [...trip.tasks]
                                                newTasks[index].destinationCity = e.target.value
                                                setTrip({ ...trip, tasks: newTasks })
                                            }} type="text" placeholder="Enter Destination City" />
                                        </Form.Group>
                                        <Form.Group className="col-6" controlId="formBasicDestinationState">
                                            <Form.Label>Destination State</Form.Label>
                                            <Form.Control value={task?.destinationState} onChange={(e) => {
                                                let newTasks = [...trip.tasks]
                                                newTasks[index].destinationState = e.target.value
                                                setTrip({ ...trip, tasks: newTasks })
                                            }} type="text" placeholder="Enter Destination State" />
                                        </Form.Group>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            <i className="fa fa-trash mt-4" style={{ cursor: "pointer" }} onClick={() => {
                                let newTasks = [...trip.tasks]
                                newTasks.splice(index, 1)
                                setTrip({ ...trip, tasks: newTasks })
                            }}></i>
                        </div>
                    })
                }
            </Accordion>


        </Modal.Body>
        <Modal.Footer>
            <button className="btn btn-primary" onClick={handleEditTask}>Submit</button>
        </Modal.Footer>

        {showMap && <MapModal show={showMap} onHide={() => setShowMap(false)} handleLocation={handleLocationSelecion} />}
    </Modal>
}